module.exports = __webpack_public_path__ + "static/media/RecomendaCamposdoJordao.cba27bf0.jpg";